/* KIT landing pages: gallery, tabs, addon, add-to-cart, sticky bar, filters, markers. */
(function () {
  if (window.__kitLpInit) return;
  window.__kitLpInit = true;
  document.documentElement.style.scrollBehavior = 'smooth';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- buy box ---- */
  document.querySelectorAll('[data-kit-buybox]').forEach(function (root) {
    var viewport = root.querySelector('.kit-gallery__viewport');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.kit-gallery__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.kit-gallery__thumb'));
    var counter = root.querySelector('[data-kit-counter]');
    var totalSlides = slides.length;

    var programmaticScroll = 0;
    function markActive(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + totalSlides;
    }
    function setActive(i) {
      markActive(i);
      if (!viewport) return;
      if (window.innerWidth >= 750) { viewport.scrollTo({ left: 0 }); return; }
      var target = viewport.clientWidth * i;
      if (Math.abs(viewport.scrollLeft - target) < 2) return;
      clearTimeout(programmaticScroll);
      programmaticScroll = setTimeout(function () { programmaticScroll = 0; }, 1200);
      viewport.scrollTo({ left: target, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setActive(i); });
    });
    if (viewport) {
      viewport.addEventListener('scroll', function () {
        if (window.innerWidth >= 750) return;
        var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
        if (programmaticScroll) {
          if (Math.abs(viewport.scrollLeft - viewport.clientWidth * i) < 2) { clearTimeout(programmaticScroll); programmaticScroll = 0; }
          return;
        }
        if (i >= 0 && i < totalSlides) markActive(i);
      }, { passive: true });
    }

    /* tabs */
    root.querySelectorAll('.kit-tabs__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('.kit-tabs__tab').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        root.querySelectorAll('.kit-tabs__panel').forEach(function (p) { p.hidden = true; });
        var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      });
    });

    /* add-on + totals */
    var addon = root.querySelector('[data-kit-addon]');
    var addonPrice = parseInt(root.getAttribute('data-addon-cents') || '0', 10);
    var baseCents = parseInt(root.getAttribute('data-total-cents') || '0', 10);
    function syncTotals() {
      var extra = addon && addon.checked ? addonPrice : 0;
      var total = baseCents + extra;
      root.querySelectorAll('[data-kit-total]').forEach(function (el) { el.textContent = money(total); });
      root.querySelectorAll('[data-kit-cta-price]').forEach(function (el) { el.textContent = money(total); });
    }
    if (addon) addon.addEventListener('change', syncTotals);
    syncTotals();

    /* add to cart */
    var btn = root.querySelector('[data-kit-add]');
    if (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var items = [];
        try {
          items = JSON.parse(root.getAttribute('data-kit-items') || '[]');
        } catch (e) { items = []; }
        if (addon && addon.checked && root.getAttribute('data-addon-id')) {
          items.push({ id: parseInt(root.getAttribute('data-addon-id'), 10), quantity: 1 });
        }
        if (!items.length) { window.location.href = '/cart'; btn.disabled = false; return; }
        window.lpaCartAdd(items).finally(function () { btn.disabled = false; });
      });
    }
  });

  /* ---- reviews summary: topic filter + load more ---- */
  document.querySelectorAll('[data-kit-rsum]').forEach(function (root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('.kit-chip'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('.kit-rrow'));
    var loadBtn = root.querySelector('[data-kit-loadmore]');
    var active = 'all';
    var expanded = false;

    function apply() {
      var shown = 0;
      var matching = 0;
      rows.forEach(function (row) {
        var topics = (row.getAttribute('data-topics') || '').split(',');
        var match = active === 'all' || topics.indexOf(active) !== -1;
        if (match) matching++;
        var visible = match && (expanded || matching <= 4);
        row.style.display = visible ? '' : 'none';
        if (visible) shown++;
      });
      if (loadBtn) loadBtn.style.display = (!expanded && matching > 4) ? '' : 'none';
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        active = chip.getAttribute('data-topic') || 'all';
        apply();
      });
    });
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        expanded = true;
        apply();
      });
    }
    apply();
  });

  /* ---- mapped markers ---- */
  document.querySelectorAll('[data-kit-mapped]').forEach(function (root) {
    root.querySelectorAll('.kit-tile__marker').forEach(function (marker) {
      marker.addEventListener('click', function () {
        var tile = marker.closest('.kit-tile');
        var key = marker.getAttribute('data-detail');
        tile.querySelectorAll('.kit-tile__marker').forEach(function (m) { m.classList.remove('is-active'); });
        marker.classList.add('is-active');
        tile.querySelectorAll('.kit-tile__detail').forEach(function (d) {
          d.classList.toggle('is-active', d.getAttribute('data-detail') === key);
        });
      });
    });
  });

  /* ---- sticky bar ---- */
  document.querySelectorAll('.kit-sticky').forEach(function (bar) {
    var trigger = document.querySelector('[data-kit-sticky-trigger]');
    var buybox = document.getElementById('kit-buybox');
    var past = false;
    var inBuybox = false;
    function sync() { bar.classList.toggle('is-visible', past && !inBuybox); }
    if (trigger && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        sync();
      }).observe(trigger);
    }
    if (buybox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        inBuybox = e[0].isIntersecting;
        sync();
      }).observe(buybox);
    }
  });
})();

/* ---- reviews by product (Yotpo widget API, one tab per bundle item) ---- */
(function () {
  document.querySelectorAll('[data-kit-rtabs]').forEach(function (root) {
    var key = root.getAttribute('data-app-key');
    var raw = root.querySelector('[data-rtab-products]');
    if (!key || !raw) return;
    var products = [];
    try {
      JSON.parse(raw.textContent).split('||').forEach(function (p) {
        var parts = p.split('|');
        if (parts[0]) products.push({ id: parts[0], title: parts[1] || '' });
      });
    } catch (e) { return; }
    if (!products.length) return;

    var list = root.querySelector('[data-rtab-list]');
    var more = root.querySelector('[data-rtab-more]');
    var avgEl = root.querySelector('[data-rtab-avg]');
    var starsEl = root.querySelector('[data-rtab-stars]');
    var totalEl = root.querySelector('[data-rtab-total]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rtab]'));
    var PAGE = 5;
    var data = {}; // id -> { reviews: [], total, avg, page, done }
    var active = 'all';
    var shown = PAGE;

    function star(filled) {
      return '<svg viewBox="0 0 24 24" fill="' + (filled ? '#1b1b1b' : 'none') + '" stroke="#1b1b1b" stroke-width="1.5" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.2 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
    }
    function stars(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) out += star(i <= Math.round(n));
      return out;
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    function fmtDate(iso) {
      var d = new Date(iso);
      return isNaN(d) ? '' : d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
    }
    function fetchPage(p) {
      var d = data[p.id] || (data[p.id] = { reviews: [], total: 0, avg: 0, page: 0, done: false, title: p.title });
      if (d.done || d.loading) return Promise.resolve(d);
      d.loading = true;
      var url = 'https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(key) + '/products/' + encodeURIComponent(p.id) + '/reviews.json?per_page=10&page=' + (d.page + 1) + '&sort=date&direction=desc';
      return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        var res = (j && j.response) || {};
        var bl = res.bottomline || {};
        d.total = bl.total_review || 0;
        d.avg = bl.average_score || 0;
        d.page += 1;
        (res.reviews || []).forEach(function (r) {
          d.reviews.push({
            score: r.score, title: r.title, content: r.content, date: r.created_at,
            name: (r.user && r.user.display_name) || 'Verified buyer',
            verified: r.verified_buyer, product: p.title
          });
        });
        if (d.reviews.length >= d.total || !(res.reviews || []).length) d.done = true;
        d.loading = false;
        return d;
      }).catch(function () { d.loading = false; d.done = true; return d; });
    }
    function current() {
      if (active !== 'all') return data[active] ? data[active].reviews.slice() : [];
      var all = [];
      products.forEach(function (p) { if (data[p.id]) all = all.concat(data[p.id].reviews); });
      all.sort(function (a, b) { return new Date(b.date) - new Date(a.date); });
      return all;
    }
    function summary() {
      var total = 0, weighted = 0;
      var ids = active === 'all' ? products.map(function (p) { return p.id; }) : [active];
      ids.forEach(function (id) {
        var d = data[id];
        if (!d) return;
        total += d.total;
        weighted += d.avg * d.total;
      });
      return { total: total, avg: total ? weighted / total : 0 };
    }
    function allLoaded() {
      var ids = active === 'all' ? products.map(function (p) { return p.id; }) : [active];
      return ids.every(function (id) { return data[id] && data[id].done; });
    }
    function render() {
      var s = summary();
      avgEl.textContent = s.total ? (Math.round(s.avg * 10) / 10).toFixed(1) : '–';
      starsEl.innerHTML = stars(s.avg);
      totalEl.textContent = s.total ? s.total + ' verified review' + (s.total === 1 ? '' : 's') : 'No reviews yet';
      products.forEach(function (p) {
        var c = root.querySelector('[data-rtab-count="' + p.id + '"]');
        if (c && data[p.id]) c.textContent = '(' + data[p.id].total + ')';
      });
      var allC = root.querySelector('[data-rtab-count="all"]');
      if (allC) {
        var t = 0; products.forEach(function (p) { if (data[p.id]) t += data[p.id].total; });
        if (t) allC.textContent = '(' + t + ')';
      }
      var rows = current();
      list.innerHTML = rows.slice(0, shown).map(function (r) {
        return '<div class="kit-rrow">' +
          '<div class="kit-rrow__stars" aria-label="' + esc(r.score) + ' out of 5 stars">' + stars(r.score) + '</div>' +
          (r.title && String(r.content || '').replace(/\s+/g, ' ').toLowerCase().indexOf(String(r.title).replace(/\s+/g, ' ').toLowerCase()) !== 0 ? '<p class="kit-rrow__title">' + esc(r.title) + '</p>' : '') +
          '<p class="kit-rrow__q">' + esc(r.content) + '</p>' +
          '<div class="kit-rrow__meta"><p class="kit-rrow__name">' + esc(r.name) + '</p>' +
          '<p class="kit-rrow__sub">' + (r.verified ? 'Verified buyer · ' : '') + esc(r.product) + (r.date ? ' · ' + fmtDate(r.date) : '') + '</p></div>' +
        '</div>';
      }).join('') || (allLoaded() ? '<p class="kit-rrow__q">No reviews for this product yet.</p>' : '<p class="kit-rrow__q">Loading reviews…</p>');
      more.hidden = !(rows.length > shown || !allLoaded());
    }
    function loadMore() {
      shown += PAGE;
      var need = current().length < shown && !allLoaded();
      if (!need) { render(); return; }
      var ids = active === 'all' ? products : products.filter(function (p) { return p.id === active; });
      Promise.all(ids.map(fetchPage)).then(render);
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        active = tab.getAttribute('data-rtab');
        shown = PAGE;
        render();
      });
    });
    more.addEventListener('click', loadMore);

    Promise.all(products.map(fetchPage)).then(render);
  });
})();
